import React from 'react';
import {Flex, useColorModeValue} from '@chakra-ui/react';

const FlexCard = props => {
  const breakpoints = props.breakpoints ? props.breakpoints : {base: 'column', md: 'row'};
  return (
    <Flex
      boxShadow="lg"
      rounded="md"
      border="1px"
      borderColor="blackAlpha.200"
      p="3"
      mb="2"
      mt="0"
      bg={useColorModeValue('tertiary.50', 'gray.700')}
      flexDir={breakpoints}
      alignItems={props.alignItems}
      w={props.w}
      m={props.m}
      my={props.my}
      mr={props.mr}
    >
      {props.children}
    </Flex>
  );
};

export default FlexCard;
